<template>
  <div class="w-full users relative">
    <vx-card class="clearfix mb-5">
      <vs-row class="mb-5">
        <vs-col class="flex flex-wrap">
          <div class="w-full md:flex justify-between">
            <div class="lg:w-1/4 mb-5">
              <h2>
                Users
                <span class="font-hairline">Of {{ accountName }}</span>
              </h2>
            </div>
            <div class="w-full lg:w-1/2 md:flex justify-end search-div">
              <div class="w-full lg:w-1/2">
                <span class="font-bold float-left w-1/4 pt-2 pr-5 text-right">Filter by</span>
                <v-select
                  id="settings-users-filter-by-list"
                  label="text"
                  :options="rolesOptionsObjForFilter()"
                  class="md:w-3/4 md:float-left"
                  v-on:input="applyFilters"
                  placeholder="Filter by"
                  v-model="agFilters.filterDropdown.select"
                ></v-select>
              </div>
              <div class="w-full lg:w-1/4 lg:pl-3" v-if="isInvitationEnabled()">
                <vs-button
                  id="settings-users-add-new-user-button"
                  @click="inviteUserInputs.popup=true"
                  icon="add"
                  class="w-full font-bold rounded md:mt-0 mt-4"
                  size="small"
                >Add New User
                </vs-button>
              </div>
            </div>
          </div>
        </vs-col>
      </vs-row>

      <vs-row>
        <a-g-speakol-table
          ref="subUserTable"
          :filters="agFilters"
          :columns="agColumns"
          :options="agOptions"></a-g-speakol-table>
      </vs-row>
    </vx-card>

    <vs-popup title class="invite-popup" v-if="isInvitationEnabled()" :active.sync="inviteUserInputs.popup">
      <div class="w-full h-full p-6">
        <h2 class="mb-20">Add New User</h2>
        <VuePerfectScrollbar class="scroll-area">
          <div class="mb-7" :key="index" v-for="(n, index) in inviteUserInputs.inputCount">
            <div class="w-full">
              <div class="flex flex-wrap mb-5 sm:space-y-9">
                <div class="w-full md:w-7/12 md:pr-6 md:mb-0 mb-4">
                  <div class="relative">
                    <label class="text-dark">Email</label>

                    <vs-input
                      id="settings-users-pop-up-email-input"
                      class="block w-full mt-2"
                      :data-vv-name="'email'+index"
                      placeholder="Email"
                      v-model="inviteUserInputs.inputs[index].email"
                      v-validate="'required|email'"
                      data-vv-validate-on="input|keyup|blur"
                    />
                    <span
                      class="delete-invite-input"
                      v-if="index > 0"
                      @click="deleteRow(index)"
                      radius
                      color="danger"
                      size="medium"
                      type="flat"
                      icon="delete"
                    >
                      <img src="@/assets/images/pages/settings/users/delete.svg"/>
                    </span>
                  </div>

                  <p
                    class="text-danger text-sm"
                    v-if="errors.first('email'+index)"
                  >{{ errors.first('email' + index).replace(/[0-9]/g, '') }}</p>
                </div>

                <div class="w-full md:w-5/12 md:mb-0">
                  <label class="text-dark">Role</label>
                  <v-select
                    id="settings-users-pop-up-role-list"
                    class="style-chooser block w-full mt-2"
                    :data-vv-name="'role'+index"
                    label="text"
                    placeholder="Role"
                    :reduce="option => option.value"
                    :options="inviteUserInputs.rolesOptions"
                    v-model="inviteUserInputs.inputs[index].role"
                    v-validate="'required'"
                    data-vv-validate-on="input|keyup|blur"
                  >
                    <template v-slot:option="option">
                      <div class="element" :class="option.text">
                        <div>
                          {{ option.text }}
                          <!-- @mouseover="showIcon(option.value)" -->
                          <!-- <img
                            class="float-right true-icon mt-5"
                            :class="option.value"
                            src="@/assets/images/pages/settings/users/true.png"
                          /> -->
                        </div>
                      </div>
                    </template>
                  </v-select>
                  <p
                    class="text-danger text-sm"
                    v-if="errors.first('role'+index)"
                  >{{ errors.first('role' + index).replace(/[0-9]/g, '') }}</p>
                </div>
              </div>
            </div>
          </div>
          <div class="w-full text-right add-another-user">
            <a id="settings-users-pop-up-add-new-button" v-on:click="addAnotherUser" disabled="true" href="#">Add Another User</a>
          </div>

          <span
            class="text-danger text-sm block"
            v-show="errors.has('invitationResponseError')"
          >{{ errors.first('invitationResponseError') }}</span>

          <div class="w-full md:text-right relative">
            <vs-button id="settings-users-pop-up-invite-button" class="invite-button" v-on:click="inviteUsers" size="medium">Invite</vs-button>
            <vs-button
              id="settings-users-pop-up-cancel-button"
              class="cancel-button"
              type="border"
              v-on:click="resetInvitePopup"
              size="medium"
            >Cancel
            </vs-button>
          </div>
        </VuePerfectScrollbar>
      </div>
    </vs-popup>

    <div class="success-add-new-user">
      <vs-popup class="add-new-user-success-pop-up" title :active.sync="inviteUserInputs.successPopup">
        <img src="@/assets/images/pages/settings/success.svg" class="add-new-uer-success-pop-up-img center"/>
        <p class="pop-up-text text-center ">Invitation has been successfully sent.</p>
        <vs-button
          size="medium"
          @click="inviteUserInputs.successPopup=false"
          class="shadow-none success-button center"
        >Ok
        </vs-button>
      </vs-popup>
    </div>

  </div>
</template>

<script>
const rolesFilters = [
  {
    text: 'All Users',
    value: ''
  },
  {
    text: 'Ad Ops',
    value: 'ad_ops'
  },
  {
    text: 'Super Admin',
    value: 'super_admin'
  },
  {
    text: 'Editor',
    value: 'editor'
  },
  {
    text: 'Sales',
    value: 'sales'
  },
  {
    text: 'Viewer',
    value: 'viewer'
  },
  {
    text: 'Account Manager',
    value: 'account_manager'
  },
  {
    text: 'Sales Manager',
    value: 'sales_manager'
  },
  {
    text: 'Admin',
    value: 'admin'
  },
  {
    text: 'Finance',
    value: 'finance'
  }
]
import AGSpeakolTable from '@/components/AGSpeakolTable'
import VuePerfectScrollbar from 'vue-perfect-scrollbar'
import SubUserDataSource from '@/datasources/SubUserSource'
import AgGridUserActions from './components/AgGridUserActions.vue'
import AgGridUserStatus from './components/AgGridUserStatus.vue'
import AgGridUserName from './components/AgGridUserName.vue'

export default {
  components: {
    VuePerfectScrollbar,
    AGSpeakolTable,
    usersAction: AgGridUserActions,
    usersStatus: AgGridUserStatus,
    usersName: AgGridUserName
  },
  data () {
    return {
      filterDropdown: {
        select: {},
        options: this.rolesOptionsObj()
      },
      agFilters: {
        role: null,
        filterDropdown: {
          select: {},
          options: this.rolesOptionsObj()
        }
      },
      agOptions: {
        dataSource: SubUserDataSource,
        context: {
          parent:this
        }
      },
      agColumns: [
        {
          headerName: 'Name',
          field: 'user_name',
          minWidth: 400,
          cellRendererFramework: 'usersName'
        },
        {
          headerName: 'Status',
          field: 'status',
          minWidth: 150,
          cellRendererFramework: 'usersStatus',
          valueGetter (params) {
            if (params.data) {
              return params.data.status === 1 ? 'Aceepted' : 'not accepted'
            }
          }
        },
        {
          headerName: 'Role',
          field: 'role',
          minWidth: 200,
          valueGetter (params) {
            if (params.data) {
              return params.data.role.charAt(0).toUpperCase() + params.data.role.slice(1)
            }
          }
        },
        {
          headerName: 'Actions',
          field: 'ctr',
          minWidth: 180,
          cellRendererFramework: 'usersAction'
        }
      ],
      accountName: this.$store.getters['authentication/activeAccount']['name'],
      currentUserEmail: this.$store.getters['authentication/user']['email'],
      users: [],
      filteredUsers: [],
      inviteUserInputs: this.getIntialInvitePopup(),
      accountOwner: {},
      defaultAvailableInvitationsCount: 7,

      total: 1,
      perPage: 25,
      maxPagesNumber: 7,
      usersCount: 0,
      allUsersCount: 0,
      pageNumber: 1,
      pageCounts: {
        options: [25, 50, 100, 250]
      }
    }
  },

  created () {
    this.loadUsers()
  },

  methods: {
    applyFilters () {
      this.agFilters.role = this.agFilters.filterDropdown.select !== 'All' ? this.agFilters.filterDropdown.select.value : null
      this.$refs['subUserTable'].applyFilters()
    },
    async loadUsers () {


      const response = await this.getInvitationsData()

      this.accountOwner = response.accountOwner

      this.setMaxPageNumbers()


    },

    setMaxPageNumbers () {
      if (typeof window.orientation !== 'undefined') {
        this.maxPagesNumber = 5
      } else {
        this.maxPagesNumber = this.total > 10 ? 10 : 7
      }
    },

    async changeRowsCount () {
      this.pageNumber = 1
      await this.getInvitationsData()
    },

    getRoleTextByValue (val) {
      if (!val) {
        return
      }
      return rolesFilters.find((role) => role.value === val).text
    },
    showIcon (index) {
      document.querySelector(`.true-icon.${index}`).style.display = 'block'

      document.querySelectorAll(`.true-icon:not(.${index})`).forEach((ele) => {
        ele.style.display = 'none'
      })
    },
    deleteRow (index) {
      this.inviteUserInputs.inputCount--
      this.inviteUserInputs.inputs.splice(index, 1)
    },
    addAnotherUser () {
      this.inviteUserInputs.inputCount++
      this.inviteUserInputs.inputs.push({
        email: '',
        role: ''
      })
    },
    rolesOptionsObj () {
      const roles = []
      if (this.$can('invite_super_admin')) {
        roles.push({
          text: 'Super Admin',
          value: 'super_admin'
        })
        roles.push({
          text: 'Account manager',
          value: 'account_manager'
        })
        roles.push({
          text: 'Finance',
          value: 'finance'
        })
      }
      if (this.$can('invite_admin')) roles.push({
        text: 'Admin',
        value: 'admin'
      })
      if (this.$can('invite_editor')) roles.push({
        text: 'Editor',
        value: 'editor'
      })
      if (this.$can('invite_viewer')) roles.push({
        text: 'Viewer',
        value: 'viewer'
      })
      return roles
    },

    rolesOptionsObjForFilter () {
      if (!this.$can('invite_editor')) {
        return [
          {
            text: 'All',
            value: 'all'
          },
          {
            text: 'Admin',
            value: 'admin'
          },
          {
            text: 'Editor',
            value: 'editor'
          },
          {
            text: 'Viewer',
            value: 'viewer'
          }
        ]
      }

      return [
        {
          text: 'All',
          value: 'all'
        },
        ...this.rolesOptionsObj()
      ]
    },

    isInvitationEnabled () {
      return !!this.rolesOptionsObj().length
    },

    getIntialInvitePopup () {
      return {
        inputCount: 1,
        inputs: [
          {
            email: '',
            role: ''
          }
        ],
        select: '',
        successPopup: false,
        popup: false,
        email: '',
        rolesOptions: this.rolesOptionsObj()
      }
    },
    resetInvitePopup () {
      this.$validator.reset()
      this.inviteUserInputs = this.getIntialInvitePopup()
    },
    async resendInvitation (id) {
      try {
        await this.$store.dispatch('settings/reSendInvitations', {
          id
        })

        this.inviteUserInputs.successPopup = true
      } catch (e) {
        // show error popup
      }
    },

    async getInvitationsData () {
      const res = await this.$store.dispatch('settings/getInvitations', {
        perPage: this.perPage,
        role: this.agFilters.filterDropdown.select !== 'All' ? this.filterDropdown.select.value : null,
        page: this.pageNumber
      })

      return res.data
    },

    async inviteUsers () {
      try {
        await this.$validator.validateAll()

        this.validateInviteInputsAgainstUserEmails()

        if (!this.errors.any()) {

          await window.axios.post('/users/invitations', {
            invitations: this.inviteUserInputs.inputs
          })

          await this.loadUsers()

          this.inviteUserInputs.popup = false
          this.resetInvitePopup()
          this.inviteUserInputs.successPopup = true
          this.$vs.loading.close()
          this.$refs['subUserTable'].refreshGrid()
        }
      } catch (error) {
        this.errors.add({
          field: 'invitationResponseError',
          msg:
            error.response &&
            error.response.data &&
            error.response.data.message
        })
      }
    },
    validateInviteInputsAgainstUserEmails () {
      for (let i = 0; i < this.inviteUserInputs.inputs.length; i++) {
        const {email} = this.inviteUserInputs.inputs[i]

        const existingEmails = this.inviteUserInputs.inputs.filter(
          (el) => el.email === email
        )

        if (existingEmails.length > 1) {
          this.errors.add({
            field: `email${i}`,
            msg: 'This email is duplicated.'
          })
          continue
        }

        if (this.currentUserEmail.toLowerCase() === email.toLowerCase()) {
          this.errors.add({
            field: `email${i}`,
            msg: 'You can not invite your email.'
          })
          continue
        }

        this.$refs['subUserTable'].api.forEachNode(node => {
          if (email === node.data.email) {
            this.errors.add({
              field: `email${i}`,
              msg: 'This user is already exist'
            })
          }
        })

        // Validate Account Owner
        if (email === this.accountOwner.email) {
          this.errors.add({
            field: `email${i}`,
            msg: 'You can not invite your account owner'
          })
          break
        }
      }
    }
  },
  computed: {
    invitationPopupStatus () {
      return this.inviteUserInputs.popup
    },
    invitationSuccessPopupStatus () {
      return this.inviteUserInputs.successPopup
    }
  },
  watch: {
    pageNumber () {
      this.loadUsers()
    },
    perPage () {
      this.loadUsers()
    },

    invitationPopupStatus () {
      return document
        .querySelector('body')
        .classList.toggle('invitation-popup-open')
    },
    invitationSuccessPopupStatus () {
      return document
        .querySelector('body')
        .classList.toggle('invitation-popup-open')
    }
  },
  mounted () {
    this.$parent.setupTabsBar()
  }
}
</script>

<style lang="scss">
.footer {
  padding-top: 30px !important;
  margin-bottom: 50px;

  .vs__dropdown-toggle {
    border-radius: 20px;
    min-width: 110px;
  }

  .vs__selected {
    padding-left: 17px;
  }
}

.center {
  display: block;
  margin-left: auto;
  margin-right: auto;
  width: 30%;
}

.table-with-min-width table {
  min-width: 600px;
}

::placeholder,
.vs-input--placeholder {
  color: #dadada !important;
}

.vs-input--placeholder {
  color: #dadada !important;
}

.scroll-area {
  position: relative;
  max-height: 400px;
  padding-right: 15px;
}

.delete {
  left: 90%;
  top: 20%;
  cursor: pointer;
}

.vs-popup--content {
  max-height: none !important;
  padding-right: 0 !important;
}

div.btns {
  margin-bottom: 30px;
}

@media (max-width: 768px) {
  .delete {
    top: 48%;
  }

  .vs-pagination--mb {
    justify-content: center !important;
  }
}

.true-icon {
  display: none;
}

.users {
  color: #2c2c2c !important;
  letter-spacing: 0.107143px;

  table th {
    background: rgba(0, 146, 215, 0.06);
    padding-top: 20px !important;
    padding-bottom: 20px !important;
    font-weight: 500;
    font-size: 16px;
    line-height: 24px;
    color: #404040;
  }
}

.search-div {
  button,
  .vs__dropdown-toggle {
    height: 40px !important;
  }
}

.vs-popup {
  border-radius: 15px !important;
}

.avatar-status {
  left: 0;
  top: 20px;
}

.add-another-user {
  font-family: Poppins;
  font-style: normal;
  font-weight: 500;
  font-size: 14px;
  line-height: 21px;
  color: #0092d7;
  margin-bottom: 48px;
}

.invite-button {
  width: 30%;
  height: 48px;
  background: #0092d7;
  border-radius: 3px;
  position: absolute;
  right: 0%;
  font-family: Poppins;
  font-style: normal;
  font-weight: 500;
  font-size: 14px;
  box-shadow: 0 4px 30px rgba(91, 111, 121, 0.25);
  text-align: center;
}

.cancel-button {
  width: 25%;
  height: 48px;
  background: #fff;
  border-radius: 3px;
  position: absolute;
  left: 42%;
  font-family: Poppins;
  font-style: normal;
  font-weight: 500;
  font-size: 14px;
  color: rgba(0, 0, 0, 0.65) !important;
  box-shadow: 0 4px 30px rgba(91, 111, 121, 0.25);
  border: 2px solid #d9d9d9;
  text-align: center;
}

.invite-popup {
  width: 100%;
  height: 100%;
}

.ps-container {
  height: 220px;
}

.delete-invite-input {
  position: absolute;
  top: 55%;
  left: 90%;
}

.vs__clear {
  visibility: hidden;
}

.invitation-popup-open {
  overflow: hidden;
}

.add-new-user-success-pop-up {
  .vs-popup--content {
    // width:613px;
    padding-top: 50px;
    padding-bottom: 50px;
    border-radius: 16px;
  }
}

.add-new-uer-success-pop-up-img {
  width: 130px;
}

.pop-up-text {
  margin-top: 24px;
}

.success-button {
  width: 250px;
  height: 48px;
  border-radius: 3px;
  margin-top: 27px;
  background-color: #0092d7 !important;
}

@media (max-width: 576px) {
  .pop-up-text {
    margin-top: 16px;
  }

  .success-button {
    margin-top: 16px;
    width: 240px;
    height: 40px;
  }
}
</style>
